/**
 * Specifies how weather index units are to be calculated.
 * tag: 41199
 * @readonly
 * @enum {number} (int)
 */
export enum PaymentStreamSettlLevel {
  Average = 0,
  Maximum = 1,
  Minimum = 2,
  Cumulative = 3,
}
